import { CampaignModel } from "../campaigns/campaign.model";
import { RevisionHistory } from "../revision/revision-history.model";
import { revisionPartVOs } from "../revision/revision-part-vo.model";
import { RevisionModel } from "../revision/revision.model";
import { ScheduleServices } from "../schedule/schedule-services.model";

export class SelectedServices {
  "revisionHistory": RevisionHistory[];
  "offeredServices": ScheduleServices[];
  "totalPrice": number;
  "onRequest": boolean;
  "details": string;
  "revisionPrice": number;
  "selectedRevision" : ScheduleServices;
  "revisionParts": revisionPartVOs[];
  "revisionInfo": RevisionModel[];
  "campaigns": CampaignModel[];
}
